import React from 'react'
import { Field } from 'view/components/inputs'
import { Selectbox } from 'view/components/options'
import { Locale, Translation } from 'locale'
import { BooleanSelectboxProps } from './BooleanSelectbox'

export const InitiatedGridSelectBox = React.forwardRef((props: BooleanSelectboxProps, ref: React.Ref<Selectbox>) => {
  return (
    <Selectbox
      ref={ref}
      optionKeys={[true, false]}
      getOptionText={(option: boolean) =>
        option ? Locale.translate(Translation.TC_GRID_COUNTERPARTY) : Locale.translate(Translation.TC_GRID_DEFAULT)
      }
      {...props}
    />
  )
})

export const InitiatedGridSelectBoxField = Field(InitiatedGridSelectBox)
